import { Link } from 'react-router-dom';
import { Wind, Mail, Youtube } from 'lucide-react';

const SiteFooter = () => {
  return (
    <footer 
      className="text-white py-12"
      style={{
        backgroundImage: 'url(/images/footer-bg.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Semi-transparent overlay for better text readability */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center">
                <Wind className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-lg text-white" style={{ fontFamily: 'Space Grotesk, sans-serif', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
                Respiration Santé
              </span>
            </div>
            <p className="text-white/90 text-sm" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
              Rééducation des troubles respiratoires : hyperventilation, respiration dysfonctionnelle et COVID Long.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>Navigation</h4>
            <div className="flex flex-col gap-2 text-sm text-white/90" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
              <Link to="/hyperventilation" className="hover:text-cyan-300 transition-colors">Hyperventilation</Link>
              <Link to="/respiration-dysfonctionnelle" className="hover:text-cyan-300 transition-colors">Respiration Dysfonctionnelle</Link>
              <Link to="/covid-long" className="hover:text-cyan-300 transition-colors">COVID Long</Link>
              <Link to="/exercices" className="hover:text-cyan-300 transition-colors">Exercices de respiration</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-white" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>Contact</h4>
            <div className="flex flex-col gap-3 text-sm text-white/90" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
              <p className="font-medium text-white">Julien Jaccard</p>
              <p>Physiothérapeute, Suisse</p>
              <a href="mailto:julienjaccard@mains-nuages.ch" className="flex items-center gap-2 hover:text-cyan-300 transition-colors">
                <Mail size={16} />
                julienjaccard@mains-nuages.ch
              </a>
              <a href="https://youtube.com/@Jaccardjphysio" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-cyan-300 transition-colors">
                <Youtube size={16} />
                @Jaccardjphysio
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/30 mt-8 pt-8 pb-16 text-center text-sm text-white/90" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
          © Julien Jaccard 2025. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
